import { Link } from '@chakra-ui/react';
import React from 'react'


const LinkRenderer = (props) => {
    const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
    return (
        <Link color='blue.500' href={cellValue} isExternal>{cellValue}</Link>
    )
}

export default LinkRenderer